import { render } from "./PrintHTMLFile.vue?vue&type=template&id=53316fb4&scoped=true&ts=true"
import script from "./PrintHTMLFile.vue?vue&type=script&lang=ts"
export * from "./PrintHTMLFile.vue?vue&type=script&lang=ts"

import "./PrintHTMLFile.vue?vue&type=style&index=0&id=53316fb4&scoped=true&lang=css"

import exportComponent from "/data/code/front/deli-front-widget/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53316fb4"]])

export default __exports__